import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class InventoryFileService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  public uploadFile(file: File): Observable<void> {
    const formData = new FormData();
    formData.append('itemsCsvFile', file);

    return this.http.post<void>(`${this.baseUrl}${ApiEndpoints.INVENTORY_CSV_FILE}`, formData);
  }

  public exportFile(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}${ApiEndpoints.INVENTORY_CSV_FILE}`, {
      responseType: 'blob',
    });
  }
}
